export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) {
    // Firebase is loaded on first use; authStateReady waits until the saved session is restored
    const { auth } = await useNuxtApp().$firebase()
    await auth.authStateReady()
    if (!auth.currentUser && to.path !== '/kirjaudu') {
      return navigateTo('/kirjaudu')
    }
  }
})
